export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


export const formatKeysToPascalCase = (data) => {
   const formatted = [];

   data.forEach(obj => {
       const objFormatted = {};
       Object.keys(obj).map(key => {
          // remove _ in keys and uppercase first letter
          const formattedKey = key.split('_').map(splitKey => `${capitalizeFirstLetter(splitKey)}`).join(" ");

          objFormatted[formattedKey] = obj[key]
       })

       formatted.push(objFormatted)
   })

   return formatted;
} 